module.exports = __webpack_public_path__ + "static/media/gallery-prev.0eb07404.svg";